import React from 'react';
import styles from '../drakaisanauroski_/drakaisanauroski_.module.scss';
import Background from './src/background-links.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import MagazineIcon from '../../icons/magazineIcon.tsx';

const Drakaisanauroski_: React.FC = () => {
    return (
        <div className={styles.drakaisanauroski_}>
            <div className={styles["body-thunder"]} style={{
                backgroundImage: `url(${Background})`
            }}>
                <div
                    className={styles["container-thunder"]}
                >
                    <div className={styles["fixed-card"]}>
                        {/* <h1>Dra Kaisa Nauroski</h1> */}
                        <div className={styles.links}>
                            <LinkPersonalizado7
                                href="https://www.instagram.com/drakaisanauroski_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                title="INSTAGRAM"
                                icon={<InstagramIcon marginTop={true} height="32" color="#ffffff" />}
                                colorText="#cbb353"
                                spaceBetween={true}
                            />
                            <LinkPersonalizado7
                                href="https://maps.app.goo.gl/X9jYEoWfKZ4yt7di9"
                                title="LOCALIZAÇÃO"
                                icon={<MapsIcon height="38" color="#ffffff" />}
                                colorText="#cbb353"
                                spaceBetween={true}
                            />
                            <LinkPersonalizado7
                                href="https://wa.me/5517996776711?text=Olá, gostaria de agendar um horário."
                                title="AGENDAR"
                                icon={<WhatsappIcon height="40" color="#ffffff" />}
                                colorText="#cbb353"
                                spaceBetween={true}
                            />
                            <LinkPersonalizado7
                                linkInterno={true}
                                href="/drakaisanauroski_/procedimentos"
                                title="SOBRE MIM"
                                icon={<MagazineIcon height="34" color="#ffffff" />}
                                colorText="#cbb353"
                                spaceBetween={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Drakaisanauroski_;
